/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AllExpertCornerQueryVariables = {||};
export type AllExpertCornerQueryResponse = {|
  +allExpertCorner: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +source: string,
        +shortDescription: string,
        +link: string,
        +tags: ?$ReadOnlyArray<?string>,
        +expertCornerImage: ?string,
        +created: any,
      |}
    |}>
  |}
|};
export type AllExpertCornerQuery = {|
  variables: AllExpertCornerQueryVariables,
  response: AllExpertCornerQueryResponse,
|};
*/


/*
query AllExpertCornerQuery {
  allExpertCorner {
    edges {
      node {
        id
        source
        shortDescription
        link
        tags
        expertCornerImage
        created
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ExpertCornerNodeConnection",
    "kind": "LinkedField",
    "name": "allExpertCorner",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ExpertCornerNodeEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ExpertCornerNode",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "source",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shortDescription",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "link",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tags",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "expertCornerImage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "created",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AllExpertCornerQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AllExpertCornerQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "7c86094ec33e0ad4141f1bc9c933d4f1",
    "id": null,
    "metadata": {},
    "name": "AllExpertCornerQuery",
    "operationKind": "query",
    "text": "query AllExpertCornerQuery {\n  allExpertCorner {\n    edges {\n      node {\n        id\n        source\n        shortDescription\n        link\n        tags\n        expertCornerImage\n        created\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a7600a8970831c7f1ff4fc0f15866062';

module.exports = node;
